// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"67c1746a","220":"4b249055","420":"b6f0d580","830":"2e92fe8b","981":"6e1a0511"}[chunkId] + ".chunk.js";
};